import { STATUS_AGREEMENTS, TAB_AGREEMENTS } from 'components/pages/agreements/base/enumsAgreements';
import { defineRulesFor, updateAbility } from 'utils/can';
import { template } from 'utils/helper';
import { getWindowOptions, getWindowUser } from 'utils/hooks/storage/storageGets';

export const url_agreements = {
	change_status: template`agreements/${'slug'}/change-status/`,
	animator_administrative_fee: template`agreements/${'objectSlug'}/animator-administrative-fee/${'slug'}/`,
	animator_basic_rate: template`agreements/${'objectSlug'}/animator-basic-rate/${'slug'}/`,
	animator_prolonged_rate: template`agreements/${'objectSlug'}/animator-prolonged-rate/${'slug'}/`,
	animator_delay_interest: template`agreements/${'objectSlug'}/animator-delay-interest/${'slug'}/`,
	operating_bank: template`agreements/${'objectSlug'}/operating-bank/${'slug'}/`,
	supplier_administrative_fee: template`agreements/${'objectSlug'}/supplier-administrative-fee/${'slug'}/`,
	supplier_basic_rate: template`agreements/${'objectSlug'}/supplier-basic-rate/${'slug'}/`,
	supplier_payment_method: template`agreements/${'objectSlug'}/supplier-payment-method/${'slug'}/`,
	game_level: template`agreements/${'objectSlug'}/game-level/${'slug'}/`,
	operator_bank_account: template`agreements/${'objectSlug'}/withdrawal-bank-account/${'slug'}/`,
	animator_bank_account: template`agreements/${'objectSlug'}/animator-bank-account/${'slug'}/`,
	notification: template`agreements/${'objectSlug'}/notification/${'slug'}/`,
	animator: template`agreements/${'objectSlug'}/animator/${'slug'}/`,
	create: 'agreements/create/',
	agreement_default: 'agreements/an-domyslna-1/',
	object: template`agreements/${'slug'}/`,
	list: 'agreements/'
};

const agreements = service => ({
	deleteAgreement: slug => service.delete(url_agreements.object({ slug })),
	// Financing - Animator
	changeAgreementStatus: async (slug, status) => {
		const response = await service.put(url_agreements.change_status({ slug }), { status });
		const user = getWindowUser();
		updateAbility(defineRulesFor(user));
		return response;
	},
	addAnimatorAdministrativeFee: ({ object, values }) => service.post(url_agreements.animator_administrative_fee({ objectSlug: object.slug }), values),
	updateAnimatorAdministrativeFee: ({ object, values }) => service.put(url_agreements.animator_administrative_fee({ objectSlug: object.slug, slug: values.slug }), values),
	deleteAnimatorAdministrativeFee: ({ object, values }) => service.delete(url_agreements.animator_administrative_fee({ objectSlug: object.slug, slug: values.slug })),
	addAnimatorBasicRate: ({ object, values }) => service.post(url_agreements.animator_basic_rate({ objectSlug: object.slug }), values),
	updateAnimatorBasicRate: ({ object, values }) => service.put(url_agreements.animator_basic_rate({ objectSlug: object.slug, slug: values.slug }), values),
	deleteAnimatorBasicRate: ({ object, values }) => service.delete(url_agreements.animator_basic_rate({ objectSlug: object.slug, slug: values.slug })),
	addAnimatorProlongedRate: ({ object, values }) => service.post(url_agreements.animator_prolonged_rate({ objectSlug: object.slug }), values),
	updateAnimatorProlongedRate: ({ object, values }) => service.put(url_agreements.animator_prolonged_rate({ objectSlug: object.slug, slug: values.slug }), values),
	deleteAnimatorProlongedRate: ({ object, values }) => service.delete(url_agreements.animator_prolonged_rate({ objectSlug: object.slug, slug: values.slug })),
	addAnimatorDelayInterest: ({ object, values }) => service.post(url_agreements.animator_delay_interest({ objectSlug: object.slug }), values),
	updateAnimatorDelayInterest: ({ object, values }) => service.put(url_agreements.animator_delay_interest({ objectSlug: object.slug, slug: values.slug }), values),
	deleteAnimatorDelayInterest: ({ object, values }) => service.delete(url_agreements.animator_delay_interest({ objectSlug: object.slug, slug: values.slug })),
	addOperatingBank: ({ object, values }) => service.post(url_agreements.operating_bank({ objectSlug: object.slug }), values),
	updateOperatingBank: ({ object, values }) => service.put(url_agreements.operating_bank({ objectSlug: object.slug, slug: values.slug }), values),
	deleteOperatingBank: ({ object, values }) => service.delete(url_agreements.operating_bank({ objectSlug: object.slug, slug: values.slug })),
	// Financing - Supplier
	addSupplierAdministrativeFee: ({ object, values }) => service.post(url_agreements.supplier_administrative_fee({ objectSlug: object.slug }), values),
	updateSupplierAdministrativeFee: ({ object, values }) => service.put(url_agreements.supplier_administrative_fee({ objectSlug: object.slug, slug: values.slug }), values),
	deleteSupplierAdministrativeFee: ({ object, values }) => service.delete(url_agreements.supplier_administrative_fee({ objectSlug: object.slug, slug: values.slug })),
	addSupplierBasicRate: ({ object, values }) => service.post(url_agreements.supplier_basic_rate({ objectSlug: object.slug }), values),
	updateSupplierBasicRate: ({ object, values }) => service.put(url_agreements.supplier_basic_rate({ objectSlug: object.slug, slug: values.slug }), values),
	deleteSupplierBasicRate: ({ object, values }) => service.delete(url_agreements.supplier_basic_rate({ objectSlug: object.slug, slug: values.slug })),
	addSupplierPaymentMethod: ({ object, values }) => service.post(url_agreements.supplier_payment_method({ objectSlug: object.slug }), values),
	updateSupplierPaymentMethod: ({ object, values }) => service.put(url_agreements.supplier_payment_method({ objectSlug: object.slug, slug: values.slug }), values),
	deleteSupplierPaymentMethod: ({ object, values }) => service.delete(url_agreements.supplier_payment_method({ objectSlug: object.slug, slug: values.slug })),
	//	Program
	addLeagueGameLevel: ({ object, values }) => service.post(url_agreements.game_level({ objectSlug: object.slug }), values),
	updateLeagueGameLevel: ({ object, values }) => {
		const formData = new FormData();
		for (const [key, value] of Object.entries(values)) {
			formData.append(key, value);
		}
		if (!values?.avatar) {
			formData.delete('avatar');
		}
		return service.put(url_agreements.game_level({ objectSlug: object.slug, slug: values.slug }), formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
	},
	deleteLeagueGameLevel: ({ object, values }) => service.delete(url_agreements.game_level({ objectSlug: object.slug, slug: values.slug })),
	addOperatorBankAccount: ({ object, values }) => service.post(url_agreements.operator_bank_account({ objectSlug: object.slug }), values),
	updateOperatorBankAccount: ({ object, values }) => service.put(url_agreements.operator_bank_account({ objectSlug: object.slug, slug: values.slug }), values),
	deleteOperatorBankAccount: ({ object, values }) => service.delete(url_agreements.operator_bank_account({ objectSlug: object.slug, slug: values.slug })),
	addAnimatorBankAccount: ({ object, values }) => service.post(url_agreements.animator_bank_account({ objectSlug: object.slug }), values),
	updateAnimatorBankAccount: ({ object, values }) => service.put(url_agreements.animator_bank_account({ objectSlug: object.slug, slug: values.slug }), values),
	deleteAnimatorBankAccount: ({ object, values }) => service.delete(url_agreements.animator_bank_account({ objectSlug: object.slug, slug: values.slug })),
	addNotification: ({ object, values }) => service.post(url_agreements.notification({ objectSlug: object.slug }), values),
	updateNotification: ({ object, values }) => service.put(url_agreements.notification({ objectSlug: object.slug, slug: values.slug }), values),
	deleteNotification: ({ object, values }) => service.delete(url_agreements.notification({ objectSlug: object.slug, slug: values.slug })),
	sendEmail: ({ object, values }) => service.post(url_agreements.animator({ objectSlug: object.slug, slug: values.slug })),
	addAnimator: ({ object, values }) => service.post(url_agreements.animator({ objectSlug: object.slug }), values),
	updateAnimator: ({ object, values }) => service.put(url_agreements.animator({ objectSlug: object.slug, slug: values.slug }), values),
	deleteAnimator: ({ object, values }) => service.delete(url_agreements.animator({ objectSlug: object.slug, slug: values.slug })),
	addAgreement: values => service.post(url_agreements.create, values),
	updateAgreement: ({ slug, ...values }) => service.put(url_agreements.object({ slug }), values),
	patchAgreement: ({ object, values }) => {
		const formData = new FormData();
		for (const [key, value] of Object.entries(values)) {
			if(Array.isArray(value)) {
				for(const current of value) {
					formData.append(key, current);
				 }
			} else {
				formData.append(key, value);
			}
		}
		if (!values?.programAvatar) {
			formData.delete('programAvatar');
		}
		return service.patch(url_agreements.object({ slug: object.slug }), formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
	},
	getAgreement: async slug => {
		const response = await service.get(url_agreements.object({ slug }));
		const user = getWindowUser();
		updateAbility(defineRulesFor(user));
		return response;
	},
	getDefaultAgreement: () => service.get(url_agreements.agreement_default, {
		params: { default: true }
	}),
	getAgreements: ({ statusIn, status, operatingMode, page, rowsPerPage, currentTab, searchParameter, sortParameter, isOrderByAsc }) => {
		const order = sortParameter && `${isOrderByAsc ? '' : '-'}${sortParameter}`;
		const { paginationLimitTable } = getWindowOptions();

		const defaultOrder = {};

		const pagination = Object.assign({},
			order ? { o: order } : defaultOrder[currentTab],
			rowsPerPage && { pageSize: rowsPerPage },
			page && { page: page + 1 }
		);

		const otherParams = Object.assign({},
			searchParameter && { q: searchParameter },
			operatingMode && { operatingMode },
			statusIn && { statusIn },
			status && { status }
		);

		const filters = {
			[TAB_AGREEMENTS.ALL]: { },
			[TAB_AGREEMENTS.CREATED]: { status: STATUS_AGREEMENTS.CREATED },
			[TAB_AGREEMENTS.APPROVED]: { status: STATUS_AGREEMENTS.APPROVED },
			[TAB_AGREEMENTS.ACTIVE]: { status: STATUS_AGREEMENTS.ACTIVE },
			[TAB_AGREEMENTS.PAUSED]: { status: STATUS_AGREEMENTS.PAUSED },
			[TAB_AGREEMENTS.ENDED]: { status: STATUS_AGREEMENTS.ANNEXING },
			[TAB_AGREEMENTS.SETTLED]: { status: STATUS_AGREEMENTS.SETTLED }
		};

		return service.get(url_agreements.list, {
			params: {
				pageSize: paginationLimitTable,
				...filters[currentTab],
				...pagination,
				...otherParams
			}
		});
	}
});

export default agreements;
